import 'core-js/modules/web.timers.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import React from 'react';
import { Container, LeftPanel, PanelContent, CenterPanel, RightPanel } from './elements.js';

var defaultSidePanelWidth = 324;
var transitionTime = 260;
var CollapsablePanel = function CollapsablePanel(_ref) {
  var sidePanelLeft = _ref.sidePanelLeft,
    sidePanelRight = _ref.sidePanelRight,
    sidePanelLeftVisible = _ref.sidePanelLeftVisible,
    sidePanelRightVisible = _ref.sidePanelRightVisible,
    _ref$sidePanelLeftWid = _ref.sidePanelLeftWidth,
    sidePanelLeftWidth = _ref$sidePanelLeftWid === undefined ? defaultSidePanelWidth : _ref$sidePanelLeftWid,
    _ref$sidePanelRightWi = _ref.sidePanelRightWidth,
    sidePanelRightWidth = _ref$sidePanelRightWi === undefined ? defaultSidePanelWidth : _ref$sidePanelRightWi,
    children = _ref.children,
    persistentContent = _ref.persistentContent;
  var _React$useState = React.useState(!!sidePanelLeftVisible),
    renderLeftPanel = _React$useState[0],
    setRenderLeftPanel = _React$useState[1];
  var _React$useState2 = React.useState(!!sidePanelRightVisible),
    renderRightPanel = _React$useState2[0],
    setRenderRightPanel = _React$useState2[1];
  // Delay the un-rendering when the left sidebar is hidden
  React.useEffect(function () {
    var timeout;
    if (!sidePanelLeftVisible) {
      timeout = setTimeout(function () {
        setRenderLeftPanel(false);
      }, transitionTime);
    } else {
      setRenderLeftPanel(true);
    }
    return function () {
      if (timeout) clearTimeout(timeout);
    };
  }, [sidePanelLeftVisible]);
  // Delay the un-rendering when the right sidebar is hidden
  React.useEffect(function () {
    var timeout;
    if (!sidePanelRightVisible) {
      timeout = setTimeout(function () {
        setRenderRightPanel(false);
      }, transitionTime);
    } else {
      setRenderRightPanel(true);
    }
    return function () {
      if (timeout) clearTimeout(timeout);
    };
  }, [sidePanelRightVisible]);
  return jsxs(Container, {
    children: [sidePanelLeft && jsx(LeftPanel, {
      visible: !!sidePanelLeftVisible,
      panelWidth: sidePanelLeftWidth,
      children: jsx(PanelContent, {
        children: (renderLeftPanel || persistentContent) && sidePanelLeft
      })
    }), jsx(CenterPanel, {
      left: sidePanelLeftVisible && sidePanelLeftWidth,
      right: sidePanelRightVisible && sidePanelRightWidth,
      children: children
    }), sidePanelRight && jsx(RightPanel, {
      visible: !!sidePanelRightVisible,
      panelWidth: sidePanelRightWidth,
      children: jsx(PanelContent, {
        children: (renderRightPanel || persistentContent) && sidePanelRight
      })
    })]
  });
};

export { CollapsablePanel };
